module.exports = __webpack_public_path__ + "static/media/button_chats.54c862e1.svg";